import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';

interface SyncResult {
  success?: boolean;
  error?: string;
  fetched?: number;
  inserted?: number;
  updated?: number;
  unchanged?: number;
  skipped?: number;
  quarantined?: number;
}

export default function Beds24ConnectionTest() {
  const { session } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [isError, setIsError] = useState(false);

  const syncNow = async () => {
    if (loading) return;
    if (!window.confirm('Beds24の最新予約を今すぐ同期しますか？')) return;
    if (!session?.access_token) {
      setIsError(true);
      setMessage('認証が切れています。再ログインしてください。');
      return;
    }

    setLoading(true);
    setMessage(null);
    setIsError(false);
    try {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/beds24-sync-v2`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
        body: JSON.stringify({ mode: 'sync' }),
      });
      const result = await response.json() as SyncResult;
      if (!response.ok || !result.success) {
        setIsError(true);
        setMessage(result.error === 'sync_already_running' ? '同期処理は既に実行中です。しばらく待ってからお試しください。' : 'Beds24の同期に失敗しました。');
        return;
      }
      setMessage(`同期完了：取得 ${result.fetched ?? 0}件／新規 ${result.inserted ?? 0}件／更新 ${result.updated ?? 0}件${result.quarantined ? `／要確認 ${result.quarantined}件` : ''}`);
      window.setTimeout(() => window.location.reload(), 1200);
    } catch {
      setIsError(true);
      setMessage('通信エラーで同期できませんでした。');
    } finally {
      setLoading(false);
    }
  };

  return <div className="rounded-md border p-3" style={{ backgroundColor: '#FFFEFA', borderColor: '#DED9CC' }}>
    <div className="flex items-center justify-between gap-3">
      <div><h3 className="text-xs font-semibold" style={{ color: '#252824' }}>Beds24予約同期</h3><p className="text-[10px] mt-0.5" style={{ color: '#6B6B67' }}>通常は自動同期されます</p></div>
      <button onClick={syncNow} disabled={loading} className="flex items-center gap-1.5 rounded-md px-3 py-2 text-xs font-semibold disabled:opacity-60 cursor-pointer whitespace-nowrap" style={{ backgroundColor: '#234638', color: '#FFFEFA' }}><i className={`${loading ? 'ri-loader-4-line animate-spin' : 'ri-refresh-line'}`} />{loading ? '同期中…' : '今すぐ同期'}</button>
    </div>
    {message && <p className="mt-2 rounded px-2 py-1.5 text-[10px]" style={{ backgroundColor: isError ? '#FDF2F2' : '#F0F7F4', color: isError ? '#A33A32' : '#234638' }}>{message}</p>}
  </div>;
}
